var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入appId" },
            model: {
              value: _vm.searchData.appId,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "appId", $$v)
              },
              expression: "searchData.appId"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入应用名称" },
            model: {
              value: _vm.searchData.name,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "name", $$v)
              },
              expression: "searchData.name"
            }
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "请选择访问类别"
              },
              model: {
                value: _vm.searchData.visitType,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "visitType", $$v)
                },
                expression: "searchData.visitType"
              }
            },
            [
              _c("el-option", { attrs: { label: "对内", value: "0" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "对外", value: "1" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.searchFun }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.resetFun }
            },
            [_vm._v("重置")]
          ),
          _vm._v(" "),
          _vm.checkPermission(["app:add"])
            ? _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: { click: _vm.addFun }
                },
                [_vm._v("新增")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.newadd,
            width: "500px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.newadd = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              staticClass: "mark",
              attrs: {
                model: _vm.addData,
                rules: _vm.rules,
                "label-width": "160px"
              }
            },
            [
              _vm.title == "新增"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "appId", prop: "appId" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          maxlength: "30",
                          onkeyup: "value=value.replace(/\\s+/g,'')"
                        },
                        on: { input: _vm.onAppIdInput },
                        model: {
                          value: _vm.addData.appId,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "appId", $$v)
                          },
                          expression: "addData.appId"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title != "查看"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "应用名称", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", maxlength: "30" },
                        model: {
                          value: _vm.addData.name,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "name", $$v)
                          },
                          expression: "addData.name"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title != "查看"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "备注" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", rows: 5, maxlength: "200" },
                        model: {
                          value: _vm.addData.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "remark", $$v)
                          },
                          expression: "addData.remark"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title != "查看"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "类型", prop: "type" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.addData.type,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "type", $$v)
                            },
                            expression: "addData.type"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("App")
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("H5")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title != "查看"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "是否启用" } },
                    [
                      _c("el-checkbox", {
                        model: {
                          value: _vm.addData.enabled,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "enabled", $$v)
                          },
                          expression: "addData.enabled"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title != "查看"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "访问类别", prop: "visitType" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 0 },
                          model: {
                            value: _vm.addData.visitType,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "visitType", $$v)
                            },
                            expression: "addData.visitType"
                          }
                        },
                        [_vm._v("对内")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 1 },
                          model: {
                            value: _vm.addData.visitType,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "visitType", $$v)
                            },
                            expression: "addData.visitType"
                          }
                        },
                        [_vm._v("对外")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title != "查看"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "SDK验证", prop: "sdkCheck" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 0 },
                          model: {
                            value: _vm.addData.sdkCheck,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "sdkCheck", $$v)
                            },
                            expression: "addData.sdkCheck"
                          }
                        },
                        [_vm._v("无需验证")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 1 },
                          model: {
                            value: _vm.addData.sdkCheck,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "sdkCheck", $$v)
                            },
                            expression: "addData.sdkCheck"
                          }
                        },
                        [_vm._v("需验证")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.addData.sdkCheck == "1"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "包名", prop: "packageName" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", maxlength: "50" },
                        model: {
                          value: _vm.addData.packageName,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "packageName", $$v)
                          },
                          expression: "addData.packageName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.addData.sdkCheck == "1"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "系统类别", prop: "sysType" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择系统类别",
                            filterable: "",
                            clearable: ""
                          },
                          model: {
                            value: _vm.addData.sysType,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "sysType", $$v)
                            },
                            expression: "addData.sysType"
                          }
                        },
                        _vm._l(_vm.sysTypeList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "查看"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "秘钥" } },
                    [
                      _c("el-input", {
                        staticClass: "textarea-my",
                        attrs: { type: "textarea", rows: 8 },
                        model: {
                          value: _vm.addData.privateKey,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "privateKey", $$v)
                          },
                          expression: "addData.privateKey"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "查看"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("关 闭")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "新增"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "修改"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onUpdate }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.newadd2,
            width: "500px",
            "before-close": _vm.closeRefund,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.newadd2 = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              staticClass: "mark",
              attrs: {
                model: _vm.addData,
                rules: _vm.rules,
                "label-width": "110px"
              }
            },
            [
              _vm.title == "获取licence"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "licence值" } },
                    [
                      _c("el-input", {
                        staticClass: "textarea-my",
                        attrs: { type: "textarea", rows: 8, id: "copyObj" },
                        model: {
                          value: _vm.addData.licence,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "licence", $$v)
                          },
                          expression: "addData.licence"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "获取licence"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: { type: "primary" },
                          on: { click: _vm.copyFun }
                        },
                        [_vm._v("复制 licence")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          on: { click: _vm.onCencal2 }
                        },
                        [_vm._v("关 闭")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticClass: "mt20",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", width: "45", label: "序号" }
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "appId", label: "appId" } }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "name", label: "应用名称" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "userName", label: "维护人" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "packageName", label: "包名" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "是否SDK验证" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("sdkCheckFilters")(scope.row.sdkCheck))
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(_vm._f("typeFilters")(scope.row.type)))]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "系统类别" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("sysTypeFilters")(scope.row.sysType)))
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "访问类别" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("visitTypeFilters")(scope.row.visitType))
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("enabledFilters")(scope.row.enabled)))
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "remark", label: "备注" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { width: "140", label: "更新时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("dateFilter")(scope.row.updateTime)))
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "290", prop: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.checkPermission(["app:updata"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              title: "修改",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.updateMenu(scope.row)
                              }
                            }
                          },
                          [_vm._v("修改")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["app:del"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              title: "删除",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.delMenu(scope.row)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["app:enabled"])
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "mini" },
                            on: {
                              click: function($event) {
                                return _vm.auditFun(scope.row)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("enabledsfliters")(scope.row.enabled)
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["app:edit"])
                      ? _c(
                          "el-button",
                          {
                            attrs: { title: "查看", size: "mini" },
                            on: {
                              click: function($event) {
                                return _vm.lookView(scope.row)
                              }
                            }
                          },
                          [_vm._v("查看")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.checkPermission(["app:reset"])
                      ? _c(
                          "el-button",
                          {
                            staticClass: "mt10",
                            attrs: {
                              type: "warning",
                              title: "重置公私钥",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.reset(scope.row)
                              }
                            }
                          },
                          [_vm._v("重置公私钥")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "mt10",
                        attrs: {
                          type: "success",
                          title: "获取licence",
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            return _vm.copy(scope.row)
                          }
                        }
                      },
                      [_vm._v("获取licence")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total>0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }